module.exports = ".mat-column-accesorios {\n  padding: 8px 0px; }\n"